import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=5b1bcab4&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=5b1bcab4&prod&lang=scss&scoped=true"
import style1 from "./ColorField.vue?vue&type=style&index=1&id=5b1bcab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bcab4",
  null
  
)

export default component.exports